import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';
import { CommonStyles } from '../../../styles/Styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableNumComponentMulti } from './TableNumComponentMulti';
import { TableNumComponentRadio } from './TableNumComponentRadio';

export class TableNumComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  renderHead() {
    const thisObj = this //TODO
    return (
      <TableHead>
        <TableRow>
          <TableCell className={css(Styles.cellHeadIndex)}>
          </TableCell>
          {Object.keys(this.props.data.options).sort(function (a, b) { return (Number(thisObj.props.data.options[a].order) - Number(thisObj.props.data.options[b].order)) })
            .map((item, index) => (
              <TableCell
                className={css(Styles.cellHead)}
                key={'headCol' + index}>
                <div>
                  <p className={css(Styles.formLabel)}>{this.props.data.options[item].title}</p>
                </div>
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
    )
  }

  renderBody() {
    return (
      <TableBody>
        {
          this.props.data.subQuestions.sort((a, b) => {
            return a.order - b.order;
          }),
          this.props.data.subQuestions.map((current, itemIndex) => {
            return (
              <TableRow key={current.id}>
                <TableCell>
                  <div>
                    <p className={css(CommonStyles.questionMainTitle, Styles.questionMainTitle)}>{current.title}</p>
                  </div>
                </TableCell>
                {current.type === 'OPTIONS-MUL' &&
                  <TableNumComponentMulti
                    options={this.props.data.options}
                    handleState={this.props.handleState}
                    id={current.id}
                  />
                }
                {current.type === 'OPTIONS-SINGLE' &&
                  <TableNumComponentRadio
                    options={this.props.data.options}
                    handleState={this.props.handleState}
                    id={current.id}
                  />
                }
              </TableRow>
            )
          })
        }
      </TableBody >
    )
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <Table className={css(Styles.table)}>
            {this.renderHead()}
            {this.renderBody()}
          </Table>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    '@media (max-width: 767px)': {
      padding: 5,
    }
  },
  innerContainer: {
    //marginTop: -20,
    overflowX: 'scroll',
    '@media (max-width: 767px)': {
      marginLeft: 10,
    }
  },
  formLabel: {
    fontSize: AppTheme.subTitleSize - 4,
    margin: 0,
    marginBottom: 10,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767 - 4,
    }
  },
  cellHeadIndex: {
    minWidth: 200
  },
  cellHead: {
    fontWeight: 'unset',
    color: 'unset',
    padding: 5,
    minWidth: 120,
    textAlign: 'center'
  },
  questionMainTitle: {
    fontSize: AppTheme.subTitleSize - 4,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767 - 4,
    }
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TableNum/TableNumComponent.js